<template>
  <v-container fluid>
    <field-form
      v-if="item"
      @save="save"
      :saving="saving"
      hide-default-button
      :wizard="wizard"
      :wizardSteps="currentWizard"
      :step="displayStep"
      :last-editable-step="lastEditableStep"
      :allow-editable="true"
      @cancel="cancelWizard()"
      @click-step="changeStep"
    >
      <h2 class="text-h4 mb-3">{{ $t("webboxes.title") }}</h2>
      <v-row no-gutters justify="space-between" align="center">
      <p v-html="$t('webboxes.text')">
        
      </p>
      <save-button :saving="saving" v-if="!wizard"/>
      </v-row>
      <v-alert class="mt-1" dense color="success" border="left" text>
      <v-switch color="success" id="pfid1620219493" :disabled="!canAllowWebbox" :label="!canAllowWebbox ? $t('webboxes.allow.notReady') : $t('webboxes.allow.label')" v-model="fields.boxesAllowed"/>
      </v-alert>
      <v-tabs optional v-model="tab">
        <v-tab v-for="b in boxes" :key="b.value" :href="`#${b.value}`">
          {{ b.title }}
        </v-tab>
        <v-tab key="data" href="#data">
          {{$t('webboxes.data.title')}}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="b in boxes" :key="b.value" :value="b.value">
          <p class="mt-3" v-html="b.text" />
          <web-box-configurator class="mt-3"
            :name="b.value"
            :platform="platformFromParam || item.platform"
            :box.sync="fields[`${b.value}Box`]"
          />
        </v-tab-item>
        <v-tab-item key="data" value="data">
          <raw-data />
        </v-tab-item>
      </v-tabs-items>
      <confirm-dialog title="dialog.unsaved.title" button-caption="dialog.leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          {{$t('webboxes.unsaved')}}?</confirm-dialog>
    </field-form>
    <v-row v-else>
      <v-col xs="12" lg="6" v-for="(n, i) in Array(2)" :key="i">
        <v-card><v-skeleton-loader type="card" /></v-card>
      </v-col>
      <v-col xs="12"
        ><v-card><v-skeleton-loader type="card" /></v-card
      ></v-col>
      <v-col xs="12"
        ><v-card><v-skeleton-loader type="card" /></v-card
      ></v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import ParseRoute from "@/mixins/parse-route";
import EntityForm from "@/mixins/entity-form";
import Wizards from "@/mixins/wizards";
import WebBoxConfigurator from "@/components/WebBoxConfigurator";
import RawData from "./RawData";
import ConfirmLeave from '@/mixins/confirm-leave'
import SaveButton from "@/components/SaveButton"

export default {
  name: "WebBoxes",
  mixins: [ConfirmLeave, ParseRoute, EntityForm, Wizards],
  components: { WebBoxConfigurator, RawData, SaveButton },
  data() {
    return {
      endpoint: "domains",
      fields: {
        homeBox: null,
        cartBox: null,
        productBox: null,
        boxesAllowed: null
      },
      boxes: [
        { title: this.$t('webboxes.home.title'), text: this.$t('webboxes.home.text'), value: "home" },
        { title: this.$t('webboxes.product.title'), text: this.$t('webboxes.product.text'), value: "product" },
        { title: this.$t('webboxes.cart.title'), text: this.$t('webboxes.cart.text'), value: "cart" },
        //{ text: 'Just data', value: 'data'}
      ],
      tab: "home",
    };
  },
  computed: {
    //...mapState('domains', ['item']),
    platformFromParam() {
      return this.$route.params?.platform?.toUpperCase();
    },
    ...mapGetters('domains', ['canAllowWebbox'])
  },
  methods: {
  },
  created() {
    if(this.$route.query.box) {
      this.tab = this.$route.query.box;
    }
  },
};
</script>